

<script setup >
    import HeadBar from '../components/HeadBar';
    import Foot from '../components/Foot';
    import useUser from '../composables/useUser';
    import { onMounted, ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import { isNullOrEmpty } from '../composables/utils';
    import { useHead } from '@vueuse/head';


    const { sending, loading, checkingEmail, checkingPhoneNumber, timer, view, tab, loginForm, loginFormRef, loginFormRules, login2faForm, login2faFormRef, login2faFormRules, registerForm, registerFormRef, registerFormRules, resetPasswordForm, resetPasswordFormRef, resetPasswordFormRules, onLogin, onOauth2Login, onRegister, onResetPassword, onSend2FA, onLogin2Fa, refreshVerifyCode, checkIpAddress, isCanadaIp } = useUser();

    const route = useRoute();

    function togelLoginView() {
        loginForm.value.account = "";
        loginForm.value.password = "";
        //loginForm.value.token = "";
        view.value = view.value == 'passwordLogin' ? '2faLogin' : 'passwordLogin';
    }

    const source = ref('');

    watch(() => route.query.t, (value) => {
        if (value) {
            if (value.includes('signup')) {
                tab.value = 'signup';
            } else {
                tab.value = 'signin';
            }
        } else {
            tab.value = 'signin';
        }
    }, { immediate: true });



    onMounted(() => {
        setTimeout(() => {
            const token = route.query.token;
            const account = route.query.account;
            source.value = route.query.s;

            const t = route.query.t;
            if (t?.includes('signup')) {
                tab.value = 'signup';
                registerForm.value.email = route.query.email || '';
                registerForm.value.firstName = route.query.firstname || route.query.firstName || '';
                registerForm.value.lastName = route.query.lastname || route.query.lastName || '';
                registerForm.value.phoneNumber = route.query.phone || '';
            } else {
                tab.value = 'signin';
            }

            if (token != null) {
                setTimeout(() => {
                    onOauth2Login(token);
                }, 50);
            }

            if (source.value == 'preset' && !isNullOrEmpty(account)) {
                view.value = 'preset';
                login2faForm.value.account = account;
            }
        }, 100);

        checkIpAddress();

      
    });

</script>

<template>
    <div class="home bg-white">
        <HeadBar />
        <div class="container ">
            <div class="max-w-2xl text-xl md:text-2xl  text-center mt-12 mx-auto ">

                <p v-if="source == 'preset'">Please check your mobile device for an SMS message with the six digit confirmation code. You have five minutes to enter this code. Otherwise you may press the "Resend" button.</p>
            </div>
            <div class="max-w-xl mx-auto p-12 ">
                <n-tabs default-value="signin" size="large" justify-content="space-evenly" v-if="view != 'forgotPassword'" v-model:value="tab">

                    <n-tab-pane name="signin">
                        <template #tab>
                            <div class="w-[120px] text-center font-bold">Sign In</div>
                        </template>
                        <template v-if="view == 'passwordLogin'">
                            <n-form ref="loginFormRef" size="large" :rules="loginFormRules" :model="loginForm">
                                <n-grid :x-gap="10" :y-gap="4" class="!mt-8">
                                    <n-form-item-gi span="24" label="Username" path="account">
                                        <n-input v-model:value="loginForm.account" placeholder="" :maxlength="300" autocomplete="off" clearable />
                                    </n-form-item-gi>
                                    <n-form-item-gi span="24" label="Password" path="password">
                                        <n-input v-model:value="loginForm.password" type="password" :maxlength="100" autocomplete="off" show-password-on="click" placeholder="" />
                                    </n-form-item-gi>
                                </n-grid>
                            </n-form>
                            <div class="flex justify-end">
                                <a class="hover:underline cursor-pointer " @click="view = 'forgotPassword'">Forgot password?</a>
                            </div>


                            <n-button class="mt-8 !text-black" size="large" type="primary" block strong :loading="loading" @click="onLogin">Sign In</n-button>
                        </template>

                        <template v-if="view == '2faLogin'">
                            <n-form ref="login2faFormRef" size="large" :rules="login2faFormRules" :model="login2faForm">
                                <n-grid :x-gap="10" :y-gap="4" class="!mt-8">
                                    <n-form-item-gi span="15" label="Email Address or Mobile Number" path="account">
                                        <n-input v-model:value="login2faForm.account" placeholder="" :maxlength="300" clearable />
                                    </n-form-item-gi>
                                    <n-form-item-gi span="9" label="">
                                        <n-button @click="onSend2FA(login2faForm)" :loading="sending" :disabled="timer > 0" class="w-full   !text-black">{{ timer > 0 ? `Get Code (${timer}s)` : 'Get Code' }}</n-button>
                                    </n-form-item-gi>
                                    <n-form-item-gi span="24" label="Verification Code" path="token">
                                        <n-input v-model:value="login2faForm.token" placeholder="" :maxlength="50" autocomplete="off" clearable />
                                    </n-form-item-gi>
                                </n-grid>
                            </n-form>

                            <n-button class="mt-8  !text-black" size="large" type="primary" block strong :loading="loading" @click="onLogin2Fa">Sign In</n-button>
                        </template>
                        <template v-if="view == 'preset'">
                            <n-form ref="login2faFormRef" size="large" :rules="login2faFormRules" :model="login2faForm">
                                <n-grid :x-gap="10" :y-gap="4" class="!mt-8">
                                    <n-form-item-gi span="15" label="Mobile Number" path="account">
                                        <n-input v-model:value="login2faForm.account" placeholder="" :maxlength="300" disabled clearable />
                                    </n-form-item-gi>
                                    <n-form-item-gi span="9" label="">
                                        <n-button @click="onSend2FA(login2faForm)" :loading="sending" :disabled="timer > 0" class="w-full  !text-black">{{ timer > 0 ? `Resend (${timer}s)` : 'Resend' }}</n-button>
                                    </n-form-item-gi>
                                    <n-form-item-gi span="24" label="Verification Code" path="token">
                                        <n-input v-model:value="login2faForm.token" placeholder="" :maxlength="50" autocomplete="off" clearable />
                                    </n-form-item-gi>


                                </n-grid>
                            </n-form>

                            <n-button class="mt-8  !text-black" size="large" type="primary" block strong :loading="loading" @click="onLogin2Fa">Confirm</n-button>
                        </template>
                        <n-divider class="my-4"> or </n-divider>
                        <n-button class="mt-8  !text-black" size="large" block strong @click="togelLoginView">{{ view == 'passwordLogin' ? 'Sign in with a Code' : 'Sign in with Password' }}</n-button>


                    </n-tab-pane>
                    <n-tab-pane name="signup">
                        <div v-if="!isCanadaIp" class="!text-base  text-center mx-auto  mt-4 rounded-md bg-yellow-100 p-2">
                            <div class="font-bold mb-2 ">
                                <n-icon size="18" class="text-blue-500">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z" /></svg>
                                </n-icon>
                                Heads Up
                            </div>
                            It looks like you're signing up from outside of Canada<br>
                            Contractly is currently designed for Canadian contractors and clients
                            only, and some contract terms may not apply in your region.
                        </div>
                        <template #tab>
                            <div class="w-[180px] text-center font-bold"> Create An Account</div>
                        </template>
                        <n-form ref="registerFormRef" size="large" :rules="registerFormRules" :model="registerForm">
                            <n-grid :x-gap="10" :y-gap="2" class="!mt-8" responsive="screen" item-responsive>
                                <n-form-item-gi span="24 m:12" label="Please enter your First and Last Name" path="firstName" class="name-label">
                                    <n-input v-model:value="registerForm.firstName" placeholder="First Name" :maxlength="50" clearable />
                                </n-form-item-gi>
                                <n-form-item-gi span="24 m:12" label="" path="lastName" class="mt-[-30px] md:mt-0">
                                    <n-input v-model:value="registerForm.lastName" placeholder="Last Name" :maxlength="50" clearable />
                                </n-form-item-gi>
                                <n-form-item-gi span="24" label="Please enter your 10-digit mobile number" path="phoneNumber" :show-require-mark="true">
                                    <n-popover trigger="focus" placement="bottom-start">
                                        <template #trigger>
                                            <n-input v-model:value="registerForm.phoneNumber" placeholder="Mobile Number" :maxlength="50" autocomplete="off" :loading="checkingPhoneNumber" :allow-input="(value) => !value || /^\d+$/.test(value)" clearable />

                                        </template>
                                        <div class="flex">
                                            <n-icon size="20" class="ml-[-5px]">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184s184-82.39 184-184S349.61 64 248 64z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M220 220h32v116"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M208 340h88"></path><path d="M248 130a26 26 0 1 0 26 26a26 26 0 0 0-26-26z" fill="currentColor"></path></svg>
                                            </n-icon>
                                            <span class="text-red-700 ml-1">
                                                A six digit confirmation code will be sent to this mobile number
                                            </span>
                                        </div>

                                    </n-popover>

                                </n-form-item-gi>
                                <n-form-item-gi span="24" label="Your email address will also serve as your username" path="email" :show-require-mark="true">

                                    <n-popover trigger="focus" placement="bottom-start">
                                        <template #trigger>
                                            <n-input v-model:value="registerForm.email" placeholder="Email" :loading="checkingEmail" autocomplete="off" :maxlength="200" clearable />
                                        </template>
                                        <div class="flex">
                                            <n-icon size="20" class="ml-[-5px]">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184s184-82.39 184-184S349.61 64 248 64z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M220 220h32v116"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M208 340h88"></path><path d="M248 130a26 26 0 1 0 26 26a26 26 0 0 0-26-26z" fill="currentColor"></path></svg>
                                            </n-icon>
                                            <span class="text-red-700 ml-1">
                                                A link confirming your email address will be sent to this email
                                            </span>
                                        </div>
                                    </n-popover>

                                </n-form-item-gi>

                                <n-form-item-gi span="24" label="Create a strong password: 8+ characters, mix of uppercase, lowercase, numbers, and special characters" path="password" :show-require-mark="true">
                                    <n-input v-model:value="registerForm.password" type="password" placeholder="Password" autocomplete="off" :maxlength="100" show-password-on="click" />
                                </n-form-item-gi>

                                <n-form-item-gi span="24" label="" path="confirmPassword" :show-label="false">
                                    <n-input v-model:value="registerForm.confirmPassword" type="password" placeholder="Confirm Password" autocomplete="off" :maxlength="100" show-password-on="click" />
                                </n-form-item-gi>
                                <n-form-item-gi span="13" label="" path="captcha" :show-label="false">
                                    <n-input v-model:value="registerForm.captcha" placeholder="Captcha Code" autocomplete="off" clearable />
                                </n-form-item-gi>
                                <n-form-item-gi span="11" label="" :show-label="false">
                                    <img :src="$core.captchaUrl(registerForm.captchaId)" class="ml-4 cursor-pointer mt-[-9px]" @click="refreshVerifyCode" title="Click to Refresh" />
                                </n-form-item-gi>
                            </n-grid>
                        </n-form>
                        <div class="text-red-700 text-center">NOTE: * All fields are mandatory</div>
                        <n-button class="mt-8  !text-black" size="large" type="primary" block strong :loading="loading" @click="onRegister">Register</n-button>
                    </n-tab-pane>
                </n-tabs>


                <template v-if="view == 'forgotPassword'">
                    <h2 class="text-2xl font-bold text-center mb-8">Forgot Password</h2>

                    <n-form ref="resetPasswordFormRef" size="large" :rules="resetPasswordFormRules" :model="resetPasswordForm">
                        <n-grid :x-gap="10" :y-gap="2" class="!mt-8">
                            <n-form-item-gi span="15" label="Email Address or Mobile Number" path="account">
                                <n-input v-model:value="resetPasswordForm.account" :maxlength="200" placeholder="" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi span="9" label="">
                                <n-button @click="onSend2FA(resetPasswordForm)" :loading="sending" :disabled="timer > 0" class="w-full  !text-black">{{ timer > 0 ? `Get Code (${timer}s)` : 'Get Code' }}</n-button>
                            </n-form-item-gi>
                            <n-form-item-gi span="24" label="Verification Code" path="token">
                                <n-input v-model:value="resetPasswordForm.token" :maxlength="50" placeholder="" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi span="24" label="New Password" path="password">
                                <n-input v-model:value="resetPasswordForm.password" type="password" placeholder="New Password" :maxlength="100" show-password-on="click" />
                            </n-form-item-gi>

                            <n-form-item-gi span="24" label="ConfirmPassword" path="confirmPassword">
                                <n-input v-model:value="resetPasswordForm.confirmPassword" type="password" placeholder="Confirm Password" :maxlength="100" show-password-on="click" />
                            </n-form-item-gi>
                        </n-grid>
                    </n-form>


                    <n-button class="mt-8  !text-black" size="large" type="primary" block strong :loading="loading" @click="onResetPassword">Reset Password</n-button>


                    <n-button class="mt-8 !text-black" size="large" block strong @click="togelLoginView">Back to Sign In</n-button>
                </template>

                <n-divider class="my-4"> or </n-divider>

                <div class="flex justify-around mb-4 px-12">
                    <a href="/api/auth/loginoauth2?provider=Apple&returnUrl=/login"><img src="/images/APPLE BUTTON.png" class="w-[55px]" /></a>

                    <a href="/api/auth/loginoauth2?provider=Google&returnUrl=/login"><img src="/images/GOOGLE BUTTON.png" class="w-[55px]" /></a>
                </div>


            </div>
        </div>


        <Foot />
        <CommonInfo ref="terms"></CommonInfo>
    </div>
</template>
<style>
    .name-label .n-form-item-label {
        width: 280px !important;
    }
</style>